<script>
export default {
    data: function () {
        return {
            baseRequest: {
                apiVersion: 2,
                apiVersionMinor: 0
            },
            paymentsClient: null,
            paypalRendered: false,
            allowedPaymentMethods: null,
            merchantInfo: null,
            gpayUrl: import.meta.env.VITE_URL_PAYPAL
        };
    },
    mounted: function () {
        setTimeout(() => this.onGooglePayLoaded(), 5000);
    }
    ,
    methods: {
        async getToken() {
            const PAYPAL_CLIENT_ID = import.meta.env.VITE_PAYPAL_CLIENT_ID;
            const PAYPAL_CLIENT_SECRET = import.meta.env.VITE_PAYPAL_CLIENT_SECRET;

            const base = this.gpayUrl;
            const auth = btoa(PAYPAL_CLIENT_ID + ':' + PAYPAL_CLIENT_SECRET);
            const response = await fetch(`${base}/v1/oauth2/token`, {
                method: 'POST',
                body: 'grant_type=client_credentials',
                headers: {
                    Authorization: `Basic ${auth}`
                }
            });

            const data = await response.json();
            return data.access_token;
        },
        /* Configure your site's support for payment methods supported by the Google Pay */
        getGoogleIsReadyToPayRequest(allowedPaymentMethods) {
            return Object.assign({}, this.baseRequest, {
                allowedPaymentMethods: allowedPaymentMethods
            });
        },
        /* Fetch Default Config from PayPal via PayPal SDK */

        async getGooglePayConfig() {
            let allowedPaymentMethods = this.allowedPaymentMethods;
            let merchantInfo = this.merchantInfo;
            if (
                this.allowedPaymentMethods == null ||
                this.merchantInfo == null
            ) {
                const googlePayConfig = await window.paypal.Googlepay().config();
                allowedPaymentMethods = googlePayConfig.allowedPaymentMethods;
                merchantInfo = googlePayConfig.merchantInfo;
                this.allowedPaymentMethods = allowedPaymentMethods;
                this.merchantInfo = merchantInfo;
            }
            return {
                allowedPaymentMethods,
                merchantInfo
            };
        },

        /* Configure support for the Google Pay API */
        async getGooglePaymentDataRequest() {
            const paymentDataRequest = Object.assign({}, this.baseRequest);
            const { allowedPaymentMethods, merchantInfo } =
                await this.getGooglePayConfig();
            paymentDataRequest.allowedPaymentMethods = allowedPaymentMethods;
            paymentDataRequest.transactionInfo =
                this.getGoogleTransactionInfo();
            paymentDataRequest.merchantInfo = merchantInfo;
            paymentDataRequest.callbackIntents = ['PAYMENT_AUTHORIZATION'];
            return paymentDataRequest;
        },

        onPaymentAuthorized(paymentData) {
            return new Promise((resolve, reject) => {
                this.processPayment(paymentData)
                    .then((data) => {
                        console.log(data);
                        if (data.transactionState === 'SUCCESS') {
                            resolve({
                                transactionState: 'SUCCESS',
                                transaction_id: data.transaction_id,
                                gpay_transaction_id: data.gpay_transaction_id,
                            });
                            this.isLoading = true;
                            this.SelectedData.billingData.gPayTransactionId =
                                data.gpay_transaction_id;
                            this.SelectedData.billingData.transactionId =
                                data.transaction_id;
                            //this.SelectedData.invoice = data.transaction_id;
                            this.processOrder(5);
                        } else {
                            resolve({
                                transactionState: 'ERROR',
                                error: {
                                intent: 'PAYMENT_AUTHORIZATION',
                                message: 'Payment failed, please check your card details.',
                                reason: 'PAYMENT_DATA_INVALID'
                                }
                            });
                            console.log(data);
                            const errors = [];
                            errors.push(
                                'There was a problem with your order. Please check your payment information.'
                            );
                            this.isLoading = false;
                            this.moveToStep([0, 3]);
                            this.errors = errors;
                        }
                    })
                    .catch((errDetails) => {
                        resolve({
                            transactionState: 'ERROR',
                            error: {
                            intent: 'PAYMENT_AUTHORIZATION',
                            message: 'Payment failed, please check your card details.',
                            reason: 'PAYMENT_DATA_INVALID'
                            }
                        });
                        console.log(errDetails);
                        const errors = [];
                        errors.push(
                            'There was a problem with your order. Please check your payment information.'
                        );
                        this.isLoading = false;
                        this.moveToStep([0, 3]);
                        this.errors = errors;
                    });
            });
        },

        getGooglePaymentsClient() {
            if (this.paymentsClient === null) {
                const paymentsClient = new google.payments.api.PaymentsClient({
                    environment: 'TEST',
                    //environment: 'PRODUCTION',
                    paymentDataCallbacks: {
                        onPaymentAuthorized: this.onPaymentAuthorized
                    }
                });
                this.paymentsClient = paymentsClient;
            }

            return this.paymentsClient;
        },

        async onGooglePayLoaded() {
            const paymentsClient = this.getGooglePaymentsClient();
            const { allowedPaymentMethods } = await this.getGooglePayConfig();
            const isReadyRequest = this.getGoogleIsReadyToPayRequest(
                allowedPaymentMethods
            );
            paymentsClient
                .isReadyToPay(isReadyRequest)
                .then((response) => {
                    if (response.result) {
                        //console.log(response.result);
                        // show Google Pay
                        //this.SelectedData.showGooglePayment = true;
                    } else {
                        this.SelectedData.showGooglePayment = false;
                    }
                })
                .catch(function (err) {
                    //console.error(err);
                });
        },

        async createPaypalOrder() {
            const { currencyCode, totalPrice } =
                this.getGoogleTransactionInfo();
                const order = {
                    intent: 'CAPTURE',
                    purchase_units: [
                        {
                            amount: {
                                currency_code: currencyCode,
                                value: totalPrice
                            }
                        }
                    ]
                };

            const token = await this.getToken();

            const { id } = await fetch(this.gpayUrl + `/v2/checkout/orders`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token
                },
                body: JSON.stringify(order)
            }).then((res) => res.json());
            return id;
        },

        async onApprove(data, actions) {
            try {
                const token = await this.getToken();

                const response = await fetch(
                    this.gpayUrl +
                        `/v2/checkout/orders/${data.orderID}/capture`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + token
                        }
                    }
                );

                const orderData = await response.json();
                // Three cases to handle:
                //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                //   (2) Other non-recoverable errors -> Show a failure message
                //   (3) Successful transaction -> Show confirmation or thank you message

                const errorDetail = orderData?.details?.[0];

                if (errorDetail?.issue === 'INSTRUMENT_DECLINED') {
                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    // recoverable state, per
                    // https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                    const errors = [];
                    errors.push(
                        'There was a problem with your order. Please check your payment information.'
                    );
                    this.isLoading = false;
                    this.moveToStep([0, 3]);
                    this.errors = errors;
                    return actions.restart();
                } else if (errorDetail) {
                    // (2) Other non-recoverable errors -> Show a failure message
                    const errors = [];
                    errors.push(
                        'There was a problem with your order. Please check your payment information.'
                    );
                    this.isLoading = false;
                    this.moveToStep([0, 3]);
                    this.errors = errors;
                } else if (!orderData.purchase_units) {
                    const errors = [];
                    errors.push(
                        'There was a problem with your order. Please check your payment information.'
                    );
                    this.isLoading = false;
                    this.moveToStep([0, 3]);
                    this.errors = errors;
                } else {
                    // (3) Successful transaction -> Show confirmation or thank you message
                    // Or go to another URL:  actions.redirect('thank_you.html');
                    const transaction =
                        orderData?.purchase_units?.[0]?.payments
                            ?.captures?.[0] ||
                        orderData?.purchase_units?.[0]?.payments
                            ?.authorizations?.[0];
                    /*this.resultMessage(
                                    `Transaction ${transaction.status}: ${transaction.id}<br>
          <br>See console for all available details`
                                );*/
                        this.isLoading = true;
                        this.SelectedData.billingData.gPayTransactionId =
                        orderData.purchase_units[0].payments.captures[0].id;
                        this.SelectedData.billingData.gPayCaptureId = orderData.id;
                        //this.SelectedData.invoice = orderData.purchase_units[0].payments.captures[0].id;
                        this.processOrder(5);
                    /*console.log(
                        'Capture result',
                        orderData,
                        JSON.stringify(orderData, null, 2)
                    );*/
                }
            } catch (error) {
                //console.error(error);
                /*this.resultMessage(
                                `Sorry, your transaction could not be processed...<br><br>${error}`
                            );*/
            }
        },

        loadPaymentButtons() {
            
            if(!this.paypalRendered) {
            this.paypalRendered = true;
            paypal
                .Buttons({
                    fundingSource: window.paypal.FUNDING.PAYPAL,
                    style: {
                        shape: 'rect',
                        layout: 'vertical',
                        color: 'blue',
                        label: 'pay',
                        tagline: false,

                    },
                    createOrder: this.createPaypalOrder,
                    onApprove: this.onApprove,
                })
                .render('#paypal-button-container');

                const venmoButton = window.paypal.Buttons({
                    fundingSource: window.paypal.FUNDING.VENMO,
                    style: {
                    shape: 'rect',
                    layout: 'vertical',
                    color: 'blue',
                    label: 'pay',
                    tagline: false,
                    },
                    createOrder: this.createPaypalOrder,
                    onApprove: this.onApprove,
                });
                console.log(venmoButton.isEligible());
                if (venmoButton.isEligible()) {
                    venmoButton.render('#venmo-button');
                }
            }
            

        },

        resultMessage(message) {
            const container = document.querySelector('#result-message');
            container.innerHTML = message;
        },

        addGooglePayButton() {
            const paymentsClient = this.getGooglePaymentsClient();
            const button = paymentsClient.createButton({
                onClick: onGooglePaymentButtonClicked
            });
            document.getElementById('container').appendChild(button);
        },

        getGoogleTransactionInfo() {
            return {
                displayItems: [
                    {
                        label: 'Subtotal',
                        type: 'SUBTOTAL',
                        price: this.totals.total
                    }
                ],
                countryCode: 'US',
                currencyCode: 'USD',
                totalPriceStatus: 'FINAL',
                totalPrice: this.totals.total,
                totalPriceLabel: 'Total'
            };
        },

        async onGooglePaymentButtonClicked() {
            const paymentDataRequest = await this.getGooglePaymentDataRequest();
            paymentDataRequest.transactionInfo =
                this.getGoogleTransactionInfo();
            const paymentsClient = this.getGooglePaymentsClient();
            paymentsClient.loadPaymentData(paymentDataRequest);
        },

        async processPayment(paymentData) {
            try {
                const { currencyCode, totalPrice } =
                    this.getGoogleTransactionInfo();
                const order = {
                    intent: 'CAPTURE',
                    purchase_units: [
                        {
                            amount: {
                                currency_code: currencyCode,
                                value: totalPrice
                            }
                        }
                    ]
                };

                const token = await this.getToken();

                /* Create Order */
                const res = await fetch(
                    this.gpayUrl + `/v2/checkout/orders`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + token
                        },
                        body: JSON.stringify(order)
                    }
                ).then((res) => res.json());
                
                console.log(res);
                const { id: gpayid } = res;

                
                
                const payres = await window.paypal.Googlepay().confirmOrder({
                    orderId: gpayid,
                    paymentMethodData: paymentData.paymentMethodData
                });
            
                const { status } = payres;

                const captureRes = await fetch(
                    this.gpayUrl + `/v2/checkout/orders/${gpayid}/capture`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + token
                        },
                        body: JSON.stringify(order)
                    }
                ).then((res) => res.json());
                
                const transactionId = captureRes?.purchase_units?.[0]?.payments?.captures?.[0]?.id;

                if (status === 'APPROVED' || status === 'COMPLETED') {
                    return { transactionState: 'SUCCESS', transaction_id: transactionId, gpay_transaction_id: gpayid };
                } else {
                    return { transactionState: 'ERROR' };
                }
            } catch (err) {
                return {
                    transactionState: 'ERROR',
                    error: {
                        message: err.message
                    }
                };
            }
        }
    }
};
</script>
